import {deleteIcon, permIcon, saveIcon} from "./icons";
import UrlHelpers from "./url";
import {i18n} from "./i18n";
import {FieldHandler} from "./fieldHandler";
import {Notification} from "./notification";
import {setContextActions} from "./contextActions";
import {ErrorHandler} from "./errorHandler";
import {MediamanagerFileInputHandler} from "./mediamanagerFileInput";

export class OrganizationEdit {
    private _dapi: Dapi = (<any>window).dapi;
    private _dux = (<any>window).dux;
    private _i18n: i18n = new i18n();

    constructor() {
        this._addContextActions();
        this._addMediamanager();
    }

    private _addMediamanager = () => {
        const orgaImageInputId = 'orgaIcon';
        const orgaIconInput = <HTMLInputElement>document.getElementById(orgaImageInputId);
        new MediamanagerFileInputHandler(<HTMLInputElement>document.getElementById('orgaIconFileChooser'), (source) => {
            orgaIconInput.setAttribute("value", source);
            FieldHandler.setFieldValue(orgaImageInputId, source);
            const evt = document.createEvent('HTMLEvents');
            evt.initEvent('input', false, true);
            orgaIconInput.dispatchEvent(evt);
        });

        orgaIconInput.addEventListener('input', () => {
            (<HTMLImageElement>document.getElementById('orgaIconThumbnail')).setAttribute('src', orgaIconInput.value);
        });
    };

    private _addContextActions = ():void => {
        if(this._isAdmin()) {
            let actionContext = new Array<IContextAction>();
            actionContext.push({
                title: this._i18n.getTranslation('btn_save_title'),
                icon: saveIcon,
                callback: () => {
                    this._onSave_Click();
                }
            });

            let permIconUrl = permIcon;
            actionContext.push({
                title: this._i18n.getTranslation('permission_organization_title'),
                icon: permIconUrl, //'https://s3.eu-central-1.amazonaws.com/dv-cloud-center/img/uEA6A-usergroup-32x32.png',
                href: UrlHelpers.getLinkRelHref('permission')
            });
            if (UrlHelpers.getMetaData("sysAdmin") === "1") {
                let deleteIconUrl = deleteIcon;
                actionContext.push({
                    title: this._i18n.getTranslation('organization_ctx_action_btn_delete_organization_label'), //'Organisation löschen',
                    icon: deleteIconUrl, //'https://s3.eu-central-1.amazonaws.com/dv-cloud-center/img/uEA14-delete-32x32.png',
                    callback: () => {
                        this._deleteOrganisation();
                    }
                });
            }
            // this._dapi.setContextActions(actionContext);
            setContextActions(this._dapi, this._i18n, actionContext);
        }
    };
    private _isAdmin = ():boolean => {
        let sysAdmin = UrlHelpers.getMetaData('sysAdmin');
        if (sysAdmin === "1") {
            return true;
        }
        let isAdmin = UrlHelpers.getMetaData('isAdmin');
        return isAdmin === "true"
    };

    private _onSave_Click = ():void => {
        let data = this._getValues();
        if(data) {
            let url = UrlHelpers.getLinkRelHref('self');
            let xhr = new XMLHttpRequest();
            xhr.open('PUT', url);
            xhr.setRequestHeader('accept','application/json');
            xhr.onload = () => {
                if (xhr.status === 200) {
                   this._dapi.dispatchResourceEvent({
                       name: 'changed',
                       uri: window.location.pathname
                   });
                   this._dapi.closeResourceIfMainResource();
                   Notification.showSuccessNotification(this._i18n.getTranslation('organization_edit_notification_save_success_title'), this._i18n.getTranslation('organization_edit_notification_save_success_message'));
                } else {
                    let error = ErrorHandler.parseError(xhr.responseText);
                    let isUnexpectedError = false;
                    console.error(error);
                    if (error.description.trim().startsWith("organization validation errors: ")){
                        let strFieldErrors = error.description.trim().replace('organization validation errors: ','');
                        let fieldErrors = strFieldErrors.split('|');
                        for (let i = 0; i < fieldErrors.length; i++) {
                            let fieldError = fieldErrors[i];
                            let errSplit = fieldError.split('=');
                            let fieldName = errSplit[0];
                            let errorMessageType = errSplit[1];
                            let inputId = '';
                            let errorMessage = '';
                            switch(fieldName){
                                case "name":
                                    inputId = 'orgaName';
                                    if(errorMessageType === 'missing') {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_name_empty');
                                    } else {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_name_invalid');
                                    }
                                    break;
                                case "contactMail":
                                    inputId = 'orgaContact';
                                    if(errorMessageType === 'missing') {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_contact_empty');
                                    } else {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_contact_invalid');
                                    }
                                    break;
                                case "firstName":
                                    inputId = 'orgaContactFirstName';
                                    if(errorMessageType === 'missing') {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_firstname_empty');
                                    } else {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_firstname_invalid');
                                    }
                                    break;
                                case "lastName":
                                    inputId = 'orgaContactLastName';
                                    if(errorMessageType === 'missing') {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_lastname_empty');
                                    } else {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_lastname_invalid');
                                    }
                                    break;
                                case "street":
                                    inputId = 'orgaStreet';
                                    if(errorMessageType === 'missing') {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_street_empty');
                                    } else {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_street_invalid');
                                    }
                                    break;
                                case "zip":
                                    inputId = 'orgaZip';
                                    if(errorMessageType === 'missing') {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_zip_empty');
                                    } else {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_zip_invalid');
                                    }
                                    break;
                                case "city":
                                    inputId = 'orgaCity';
                                    if(errorMessageType === 'missing') {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_city_empty');
                                    } else {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_city_invalid');
                                    }
                                    break;
                                case "taxNumber":
                                    inputId = 'orgaTaxNumber';
                                    if(errorMessageType === 'missing') {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_taxnumber_empty');
                                    } else {
                                        errorMessage = this._i18n.getTranslation('organization_edit_requiredfield_taxnumber_invalid');
                                    }
                                    break;
                            }
                            if (inputId!=='') {
                                FieldHandler.setFieldError(inputId, errorMessage);
                            } else {
                                isUnexpectedError = true;
                            }
                        }
                    // if(error.description.trim() === "E-Mail is invalid") {
                    //     let msg = this._i18n.getTranslation('organization_edit_requiredfield_contact_invalid');
                    //     FieldHandler.setFieldError("orgaContact",msg);
                    // } else if (xhr.responseText.startsWith("Not valid fields: ")) {
                    //     let msg = error.description.replace("Not valid fields: ", "");
                    //     let fields = msg.split(", ");
                    //     for(let i = 0; i<fields.length;i++){
                    //         let fieldName = "orga"+fields[i];
                    //         // remove line breaks from fieldname
                    //         fieldName = fieldName.trim().replace(/\r?\n|\r/g,"");
                    //         switch(fieldName){
                    //             case "orgaIcon":    FieldHandler.setFieldError("orgaIcon", this._i18n.getTranslation('organization_edit_validationerror_iconfield'));break;
                    //             case "orgaName":    FieldHandler.setFieldError("orgaName", this._i18n.getTranslation('organization_edit_requiredfield_name_empty'));break;
                    //             case "orgaContact": FieldHandler.setFieldError("orgaContact", this._i18n.getTranslation('organization_edit_requiredfield_contact_empty'));break;
                    //             default:            Notification.showErrorNotification(this._i18n.getTranslation('organization_edit_unexpected_save_error_title'), this._i18n.getTranslation('organization_edit_unexpected_save_error_msg'));break;
                    //         }
                    //     }
                    } else {
                        Notification.showErrorNotification(this._i18n.getTranslation('organization_edit_unexpected_save_error_title'), this._i18n.getTranslation('organization_edit_unexpected_save_error_msg'));
                    }
                    if (isUnexpectedError) {
                        Notification.showErrorNotification(this._i18n.getTranslation('organization_edit_unexpected_save_error_title'), this._i18n.getTranslation('organization_edit_unexpected_save_error_msg'));
                    }
                }
            };
            xhr.send(JSON.stringify(data));
        } else {
            console.warn("Required fields are empty!");
        }
    };

    private _getValues = (): dtoOrganization  => {
        FieldHandler.clearFieldError("orgaName");
        FieldHandler.clearFieldError("orgaContact");
        FieldHandler.clearFieldError("orgaContactFirstName");
        FieldHandler.clearFieldError("orgaContactLastName");
        FieldHandler.clearFieldError("orgaStreet");
        FieldHandler.clearFieldError("orgaZip");
        FieldHandler.clearFieldError("orgaCity");
        FieldHandler.clearFieldError("orgaTaxNumber");
        let error = false;

        let retval: dtoOrganization = {
            organization: {
                id: FieldHandler.getFieldValue('orgaId'),
                name: FieldHandler.getFieldValue('orgaName'),
                contact: FieldHandler.getFieldValue('orgaContact'),
                contactFirstName: FieldHandler.getFieldValue('orgaContactFirstName'),
                contactLastName:FieldHandler.getFieldValue('orgaContactLastName'),
                street: FieldHandler.getFieldValue('orgaStreet'),
                zip: FieldHandler.getFieldValue('orgaZip'),
                city: FieldHandler.getFieldValue('orgaCity'),
                country: FieldHandler.getFieldValue('orgaCountry'),
                icon: FieldHandler.getFieldValue('orgaIcon'),
                taxNumber: FieldHandler.getFieldValue('orgaTaxNumber')
            }
        };

        if (retval.organization.name.isNullOrEmpty()) {
            FieldHandler.setFieldError("orgaName", this._i18n.getTranslation('organization_edit_requiredfield_name_empty'));
            error = true;
        }
        if (retval.organization.contact.isNullOrEmpty()) {
            FieldHandler.setFieldError("orgaContact", this._i18n.getTranslation('organization_edit_requiredfield_contact_empty'));
            error = true;
        }
        if (error) {
            return null;
        }
        return retval;
    };

    private _deleteOrganisation = ():void =>
    {
        this._dux.query.notifier(this._i18n.getTranslation('organization_modal_delete_organization_message'), {
            title: this._i18n.getTranslation('organization_modal_delete_organization_title'),
            showClose:true,
            submit: this._i18n.getTranslation('organization_modal_delete_organization_btn_delete_label'), //'Löschen',
            priority: 'warning',
            callback: () => {
                let url = UrlHelpers.getLinkRelHref('self');
                this._deleteElement(url, true, window.location.pathname);
            }
        });
    };

    private _deleteElement = (url: string, doClose:boolean, uri: string) => {
        let xhr = new XMLHttpRequest();
        xhr.open("DELETE", url);
        xhr.setRequestHeader('accept', 'application/json');
        xhr.onload = () => {
            if (xhr.status === 204) {
                this._dapi.dispatchResourceEvent({
                    name: "deleted",
                    uri: uri
                });
                if (doClose) {
                    this._dapi.closeResourceIfMainResource();
                }
            } else {
                if (xhr.status === 401) {
                    Notification.showErrorNotification(this._i18n.getTranslation('organization_modal_delete_organization_error_not_allowed_title'), this._i18n.getTranslation('organization_modal_delete_organization_error_not_allowed_message'));
                } else if (xhr.status === 409) {
                    Notification.showErrorNotification(this._i18n.getTranslation('organization_modal_delete_organization_error_tenants_exists_title'), this._i18n.getTranslation('organization_modal_delete_organization_error_tenants_exists_message'));
                } else {
                    console.error(xhr.responseText);
                    Notification.showErrorNotification(this._i18n.getTranslation('organization_modal_delete_organization_error_unexpected_error_title'), this._i18n.getTranslation('organization_modal_delete_organization_error_unexpected_error_message'));
                }
            }
        };
        xhr.send();
    };
}

export interface dtoOrganization {
    organization: dtoOrganizationDetails;
}

export interface dtoOrganizationDetails {
    id:string;
    name:string;
    contact:string;
    contactFirstName:string;
    contactLastName:string;
    street:string;
    zip:string;
    city:string;
    country:string;
    icon:string;
    taxNumber:string;
}
